var _path, _path2, _rect, _path3, _path4, _path5, _path6, _rect2, _rect3, _rect4, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path7, _polygon, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "#18 search engine") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.44,89.86S145.54,67,114.65,70.11s-62.1,42.94-62.1,42.94l10,7.58s51.83-43,79.9-11.21S176.44,89.86,176.44,89.86Z",
    fill: "#68e1fd",
    className: "fill-primary"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.44,89.86S145.54,67,114.65,70.11s-62.1,42.94-62.1,42.94l10,7.58s51.83-43,79.9-11.21S176.44,89.86,176.44,89.86Z",
    fill: "#fff",
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 86.67,
    width: 106.1,
    height: 68.55,
    fill: "#ffd200",
    className: "fill-warning"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M324.82,233.05a13.44,13.44,0,0,1-9.23-6.91l0-.1-47.35-90.17-26.06,18.45,18.43,57.94a9.91,9.91,0,0,1-9.91,12.91c-14-.64-28.89-1-44.36-1-79.92,0-144.71,9.31-144.71,20.8s64.79,20.81,144.71,20.81S351,256.47,351,245C351,240.54,341.31,236.43,324.82,233.05Z",
    fill: "#e6e6e6",
    className: "fill-paper",
    opacity: 0.45
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.24,238.18s1.48,5,5.87,5.59,5.31,5,1.28,5.9-14-4.75-14-4.75l.63-6.35Z",
    fill: "#68e1fd",
    className: "fill-primary"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.77,237.33s-5.08,1.1-6,5.43-5.38,4.91-6,.82S82.58,230,82.58,230l6.28,1.13Z",
    fill: "#68e1fd",
    className: "fill-primary"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.45,162.67s-4.68,21.84,12.17,31.2,70-7.49,61.79,45.56h11.86s15.33-44-24.44-59.64L138.76,166.1Z",
    fill: "#24285b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 235.67,
    y: 139.91,
    width: 5.58,
    height: 36.52,
    transform: "translate(175.32 -120.92) rotate(43.7)",
    fill: "#ffd200",
    className: "fill-warning"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 235.67,
    y: 139.91,
    width: 5.58,
    height: 36.52,
    transform: "translate(175.32 -120.92) rotate(43.7)",
    opacity: 0.08
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 233.7,
    y: 138.03,
    width: 5.58,
    height: 36.52,
    transform: "translate(173.48 -120.09) rotate(43.7)",
    fill: "#ffd200",
    className: "fill-warning"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.88,
    cy: 142.03,
    rx: 17,
    ry: 11.34,
    transform: "translate(-24.2 227.46) rotate(-46.3)",
    fill: "#ffd200",
    className: "fill-warning"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.88,
    cy: 142.03,
    rx: 17,
    ry: 11.34,
    transform: "translate(-24.2 227.46) rotate(-46.3)",
    opacity: 0.08
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.91,
    cy: 140.15,
    rx: 17,
    ry: 11.34,
    transform: "translate(-23.45 225.46) rotate(-46.3)",
    fill: "#ffd200",
    className: "fill-warning"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.91,
    cy: 140.15,
    rx: 11.23,
    ry: 7.49,
    transform: "translate(-23.45 225.46) rotate(-46.3)",
    fill: "#fff",
    className: "fill-paper"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M218.25,92.33s-4.51,6.55-8.89,9.77a4,4,0,0,1-5.59-.88c-1.59-2.23-3.09-5.71-1.1-9.51l2.58-6.87A7.14,7.14,0,0,1,212.53,81C218,81.32,221.19,88.48,218.25,92.33Z",
    fill: "#f4a28c"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "206.83 86.25 186.48 94.45 188.98 108.93 203.65 96.96 206.83 86.25",
    fill: "#f4a28c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M216.52,91.33a32,32,0,0,1-5.3-5.1,6.65,6.65,0,0,1-4.63,5.62,5.4,5.4,0,0,1-6.4-2.49l6.6-7.8a8.11,8.11,0,0,1,7.76-3,29.87,29.87,0,0,1,3.69.88c3,1,5.09,5.22,8.39,5.36a1.92,1.92,0,0,1,1.55,2.91c-1.62,2.69-5.16,6.11-9.49,4.74A7.45,7.45,0,0,1,216.52,91.33Z",
    fill: "#24285b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M207.4,92.21s1.9-2.4,0-3.69-4.69,2.17-2.54,4.48Z",
    fill: "#f4a28c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M215.2,96.31l-.24,3.77a1.28,1.28,0,0,1-1.89,1l-2.71-1.5Z",
    fill: "#f4a28c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M202,98.29s.61-4.55,2.25-6.28c0,0-7.41,2.5-7.58,10.65Z",
    fill: "#ce8172",
    opacity: 0.31
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.66,153.45S67.34,106.28,124,96.31L90.71,155.22h-23Z",
    opacity: 0.08
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M191.68,113.94,190,104.17a23.86,23.86,0,0,0-14.31-18.12,42.35,42.35,0,0,0-10.09-2.65c-4.44-.62-10.66,0-17.62,1.83C118,93.1,96,118.5,91.45,149.12l-2,13.55,49.31,3.43s-2.5-14,15-14S193.42,152.28,191.68,113.94Z",
    fill: "#68e1fd",
    className: "fill-primary"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M143.36,98.79S119.43,103,93.13,140.9l-3.68,21.77,37.42,2.78Z",
    opacity: 0.08
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M170.8,116.22c4.67-15.58-13.44-28.18-26.35-18.28-10.8,8.27-23,23.16-23.48,48.29-.83,45.35,42.61,37.24,101.4,19.87l-1.87-13.21s-70.4,13.31-60.84-9.57C163.66,133.75,168.32,124.51,170.8,116.22Z",
    fill: "#68e1fd",
    className: "fill-primary"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M170.8,116.22c4.67-15.58-13.44-28.18-26.35-18.28-10.8,8.27-23,23.16-23.48,48.29-.83,45.35,42.61,37.24,101.4,19.87l-1.87-13.21s-70.4,13.31-60.84-9.57C163.66,133.75,168.32,124.51,170.8,116.22Z",
    fill: "#fff",
    opacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M146.09,179.9s1.45,50.15-57.23,59.53L86.59,228.8s47-11.65,16.64-42.86Z",
    fill: "#24285b"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 238.52,
    cy: 244.98,
    rx: 6.38,
    ry: 2.36,
    opacity: 0.08
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.92,
    cy: 238.87,
    rx: 6.38,
    ry: 2.36,
    opacity: 0.08
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.49,
    cy: 243.59,
    rx: 6.38,
    ry: 2.36,
    opacity: 0.08
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.11,
    cy: 245.96,
    rx: 6.38,
    ry: 2.36,
    opacity: 0.08
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.33,
    cy: 238.28,
    rx: 6.52,
    ry: 2.42,
    opacity: 0.08
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M220.86,155.43s16.18-1.71,17.6,4.61-1.68,9.67-16.24,5Z",
    fill: "#f4a28c"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.67,155.22s2.33,9.44,11.66,7.45S74,149.1,59.67,155.22Z",
    fill: "#f4a28c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.395e0834.svg";
export { ForwardRef as ReactComponent };